import type { AnySchema } from "yup/lib/schema";
import { FileEditAltIcon, IconButton, Paragraph, RichText, TextInput, TrashCanIcon } from "@datagame/ui";
import { ChangeEvent, useEffect, useState } from "react";

import type { Attribute, TriviaQuestion } from "../../../../../../../../gql/graphql";
import { useYupValidation } from "../../../../../../../../hooks/useYupValidation";

import styles from "./AttributeElement.module.scss";

export interface AttributeElementProps {
  attribute: Attribute | TriviaQuestion;
  value: string;
  validation?: AnySchema;
  onDelete: (id: string) => void;
  onEdit: (id: string, name: string) => void;
  isWordopolis?: boolean;
}

export const AttributeElement = ({
  attribute,
  value,
  validation,
  onDelete,
  onEdit,
  isWordopolis,
}: AttributeElementProps) => {
  const [attributeName, setAttributeName] = useState<string | undefined>(undefined);
  const { validationError, showError, setShowError } = useYupValidation(attributeName, validation);

  useEffect(() => {
    setAttributeName(value);
  }, []);

  const handleAttributeNameChange = (value: string) => {
    setShowError(false);
    setAttributeName(value);
  };
  const handleWordopolisAttributeNameChange = (event: ChangeEvent<HTMLInputElement>) => {
    setShowError(false);
    setAttributeName(event.target.value);
  };

  const handleDelete = () => {
    setShowError(false);
    onDelete(attribute.id);
  };

  const handleEditName = () => {
    if (validationError) {
      setShowError(true);
      return;
    }

    if (attributeName) onEdit(attribute.id, attributeName);
  };

  return (
    <div className={styles.attributeField}>
      <div className={styles.inputWrapper}>
        {isWordopolis ? (
          <TextInput
            value={attributeName}
            size="small"
            icon={<FileEditAltIcon />}
            onChange={handleWordopolisAttributeNameChange}
            error={showError}
            onBlur={handleEditName}
          />
        ) : (
          <RichText
            key={attribute.id}
            id={attribute.id}
            value={attributeName}
            size="small"
            icon={<FileEditAltIcon />}
            onChange={handleAttributeNameChange}
            error={showError}
            onBlur={handleEditName}
          />
        )}

        <IconButton icon={<TrashCanIcon />} className={styles.deleteBtn} onClick={handleDelete} />
      </div>
      {showError && (
        <Paragraph size="xs" className={styles.errorMessage}>
          {validationError}
        </Paragraph>
      )}
    </div>
  );
};
